import { render, staticRenderFns } from "./ChatDistributionsByUser.vue?vue&type=template&id=98b4b438&scoped=true"
import script from "./ChatDistributionsByUser.vue?vue&type=script&lang=js"
export * from "./ChatDistributionsByUser.vue?vue&type=script&lang=js"
import style0 from "./ChatDistributionsByUser.vue?vue&type=style&index=0&id=98b4b438&prod&lang=scss"
import style1 from "./ChatDistributionsByUser.vue?vue&type=style&index=1&id=98b4b438&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b4b438",
  null
  
)

export default component.exports